import React from 'react'
import { useTranslation } from 'react-i18next'
import { Text } from 'rebass'
import Modal from '../../components/Modal'
import { AutoColumn } from '../../components/Column'
import { RowBetween } from '../../components/Row'
import { ButtonError } from '../../components/Button'
import { CloseIcon } from '../../theme/components'

interface CancelOrderModalProps {
  isOpen: boolean
  orderId: number
  onDismiss: () => void
  onConfirm: () => void
  pending: boolean
}

export default function CancelOrderModal({ isOpen, orderId, onDismiss, onConfirm, pending }: CancelOrderModalProps) {
  const { t } = useTranslation()

  return (
    <Modal isOpen={isOpen} onDismiss={onDismiss} maxHeight={90}>
      <div style={{ width: '100%', padding: 24 }}>
        <RowBetween>
          <Text fontWeight={500} fontSize={20}>
            {t('orderCancel')}
          </Text>
          <CloseIcon onClick={onDismiss} />
        </RowBetween>
        <AutoColumn gap="16px" style={{ marginTop: 20 }}>
          <Text fontSize={14} style={{ textAlign: 'center' }}>
            {t('orderCancelConfirm', { id: orderId })}
          </Text>
          <ButtonError onClick={onConfirm} disabled={pending}>
            <Text fontWeight={500} fontSize={16}>
              {pending ? t('orderCancelling') : t('orderCancel')}
            </Text>
          </ButtonError>
        </AutoColumn>
      </div>
    </Modal>
  )
}
